import {
  HeightOffsetTypeProductDto,
  InstallationSetup,
  ISOPRO,
  ISOPROFireProtection,
  ISOPROHeight,
  ISOPROLoadBearingCapacity,
  ISOPROType,
  WallStructure,
} from '~/models';

export type DataTableModel<Type extends ISOPRO> =
  Record<
    ISOPROHeight,
    Record<
      ISOPROFireProtection,
      Record<
        ISOPROLoadBearingCapacity,
        Record<
          VariantGroupKey,
          Type[]
        >
      >
    >
  >;

export type CategoriesList =
  Record<
    ISOPROHeight,
    Record<
      ISOPROFireProtection,
      Record<
        WallStructure['type'],
        Record<
          ISOPROLoadBearingCapacity,
          Record<
            VariantGroupKey,
            InstallationSetup[]
          >
        >
      >
    >
  >

export type AdaptedISOPROType = ISOPROType | 'M Variant' | 'SM Variant';

export type VariantGroupKey = HeightOffsetTypeProductDto['variant'] | 'none';


export const sortVariantKeys = (variantGroup: Partial<Record<VariantGroupKey, Set<string>>>) => {
  return Object.fromEntries(Object.entries(variantGroup).sort(([var1, _], [var2, __]) =>
    var1.toLocaleString() > var2.toLocaleString() ? 1 : -1));
};
